import React from "react";
import styled from "styled-components";
import { LinkContainer } from "components/common";
import { NavDropdown, MenuItem } from "components/bootstrap";
import Routes from "routing/Routes";
import useCurrentUser from "hooks/useCurrentUser";
import Menu from "components/bootstrap/Menu";
import useLogout from "hooks/useLogout";
import NavIcon from "components/navigation/NavIcon";
import ThemeModeToggle from "./ThemeModeToggle";
const FullName = styled.span`
  text-transform: uppercase;
  font-weight: 700;
`;
const UserMenu = () => {
  const { fullName, readOnly, id: userId } = useCurrentUser();
  const route = readOnly ? Routes.SYSTEM.USERS.show(userId) : Routes.SYSTEM.USERS.edit(userId);
  const label = readOnly ? "Show profile" : "Edit profile";
  const onLogoutClicked = useLogout();
  return /* @__PURE__ */ React.createElement(NavDropdown, { title: /* @__PURE__ */ React.createElement(NavIcon, { type: "user_menu" }), hoverTitle: `User Menu for ${fullName}`, noCaret: true }, /* @__PURE__ */ React.createElement(Menu.Label, null, /* @__PURE__ */ React.createElement(FullName, null, fullName)), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(Menu.Label, null, /* @__PURE__ */ React.createElement(ThemeModeToggle, null)), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(LinkContainer, { to: route }, /* @__PURE__ */ React.createElement(MenuItem, null, label)), /* @__PURE__ */ React.createElement(MenuItem, { onClick: onLogoutClicked, icon: "logout" }, "Log out"));
};
export default UserMenu;
